import { Component, OnInit, OnDestroy, inject, signal, computed } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { CommonModule } from '@angular/common';
import { CountdownService } from '@/app/core/services/countdown.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-countdown-popup',
  imports: [TegelModule, CommonModule],
  standalone: true,
  templateUrl: './countdown-popup.component.html',
  styleUrls: ['./countdown-popup.component.css']
})
export class CountdownPopupComponent implements OnDestroy {
  countdownData = signal<{ message: string; seconds: number; callback?: () => void } | null>(null);
  private subscription: Subscription;
  private countdownService = inject(CountdownService);

  constructor() {
    this.subscription = this.countdownService.countdown$.subscribe(data => {
      this.countdownData.set(data);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  showModal = computed(() => this.countdownData() !== null);

  closeModal() {
    this.countdownData.set(null);
  }

  seconds = computed(() => this.countdownData()?.seconds || 0);

  ellipsis = computed(() => {
    const dots = '.'.repeat((this.seconds() % 4) + 1);
    return dots;
  });
}

